// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import api from 'utils/api';
import ReactSelect from 'react-select';

const fetchOptions = _.debounce((input, setOptions) => {
  api
    .get('/shared/api/counties', { params: { search_term: input } })
    .then(response => setOptions(null, { options: response.data }));
  return null;
}, 150);

const trueFunc = () => true;

const CountySelection = ({ value, onChange, onBlur, ...rest }) => (
  <ReactSelect.Async
    {...rest}
    simpleValue
    loadOptions={fetchOptions}
    valueKey="fipsCode"
    labelKey="name"
    value={value}
    onChange={onChange}
    filterOption={trueFunc}
  />
);

CountySelection.displayName = 'CountySelection';

CountySelection.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default CountySelection;
